/**
 * Repsol Theme Overrides
 * Client-specific design tokens for Repsol energy company
 */

import type { ClientThemeOverrides } from '../utils/themeAugmentation';
import logo from '../../../themes/repsol/repsol.png';

export const repsolThemeOverrides: ClientThemeOverrides = {
  clientId: 'repsol',
  logo,
  clientName: 'Repsol',
  palette: {
    light: {
      primary: {
        main: '#f9aa33',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#f9aa33',
        contrastText: '#ffffff',
      },
      atlas: {
        navigation: {
          background: '#1A3E35',
          secondaryBackground: '#f9aa33',
          text: '#FFFFFF',
          textInactive: 'rgba(255, 255, 255, 0.7)',
          activeIndicator: '#FFCC33',
          ghostButtonBorder: 'rgba(255, 255, 255, 0.3)',
        },
      },
    },
    dark: {
      primary: {
        main: '#ffb84d',
        contrastText: '#000000',
      },
      secondary: {
        main: '#ffc266',
        contrastText: '#000000',
      },
      background: {
        default: '#121212',
        paper: '#1E1E1E',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.87)',
        secondary: 'rgba(255, 255, 255, 0.6)',
      },
      atlas: {
        navigation: {
          background: '#1A3E35',
          secondaryBackground: '#c98a29',
          text: '#FFFFFF',
          textInactive: 'rgba(255, 255, 255, 0.7)',
          activeIndicator: '#FFCC33',
          ghostButtonBorder: 'rgba(255, 255, 255, 0.3)',
        },
      },
    },
  },
  typography: {
    h4: {
      color: 'rgba(0, 0, 0, 0.77)',
    },
    h5: {
      color: 'rgba(0, 0, 0, 0.77)',
    },
  },
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          minWidth: '100px',
        },
      },
    },
  },
};
